var render, staticRenderFns
import script from "./ColorType.vue?vue&type=script&lang=js&"
export * from "./ColorType.vue?vue&type=script&lang=js&"
import style0 from "./ColorType.vue?vue&type=style&index=0&id=6eb61bd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb61bd9",
  null
  
)

export default component.exports